function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("rect", {
  className: "st0",
  fill: "#F4F4F4",
  height: 99.6,
  width: 512,
  y: 106.7
}), React.createElement("rect", {
  className: "st1",
  fill: "#324095",
  height: 99.6,
  width: 512,
  y: 206.2
}), React.createElement("rect", {
  className: "st2",
  fill: "#D81F26",
  height: 99.6,
  width: 512,
  y: 305.8
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    version: 1.1,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/russia.4a6af970.svg";
export { SvgComponent as ReactComponent };